
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-result-teaser{
  display:flex;
  padding:1.75rem 0;
  border-bottom:1px solid var(--brand-neutral-gray-800);
  flex-direction:column;
  justify-content:space-between;
  font-family:var(--ff-dmsans);
}
  @media (min-width: 1280px){.se-result-teaser{
    flex-direction:row;
    column-gap:2.75rem
}
  }

.se-result-teaser--content{
  display:flex;
  flex-direction:column;
  row-gap:0.25rem;
}

[cloned-slot-name='image'] + .se-result-teaser--content{
  margin-top:2rem;
}

@media (min-width: 768px){

[cloned-slot-name='image'] + .se-result-teaser--content{
    margin-top:0
}
  }

.se-result-teaser--type{
  font-weight:var(--fw-medium);
  letter-spacing:1px;
  text-transform:uppercase;
  font-size:var(--fs-sm);
}

.se-result-teaser--link{
  font-weight:var(--fw-medium);
  font-size:var(--fs-xl);
}

@media (min-width: 768px){

.se-result-teaser--link{
    font-size:var(--fs-h4)
}
  }

.se-result-teaser--date,
.se-result-teaser--position{
  font-size:var(--fs-sm);
}

@media (min-width: 768px){

.se-result-teaser--date,
.se-result-teaser--position{
    font-size:var(--fs-base)
}
  }

.se-result-teaser--summary{
  color:var(--brand-neutral-gray-800);
  line-height:auto;
  margin:0;
  padding-top:0.75rem;
}

@media (min-width: 768px){

.se-result-teaser--summary{
    line-height:var(--lh-base)
}
  }

div[cloned-slot-name='image']{
  display:contents;
}

img{
  object-fit:cover;
  height:200px;
  width:300px;
  aspect-ratio:3/2;
}
`;